import { useEffect } from "react";

interface UndoNoticeProps {
  /** What just changed, in one sentence. */
  message: string;
  undoLabel: string;
  onUndo: () => void;
  /** Called when the notice times out; a new message starts its time afresh. */
  onDismiss: () => void;
}

/** How long the notice stays: long enough to read a sentence and reach Undo. */
const SHOWN_FOR_MS = 10_000;

/**
 * What just changed, with Undo, at the bottom of the window, as Gmail and Linear do for a
 * change that applies at once. Screen readers hear the message; it leaves after a while.
 */
export default function UndoNotice({ message, undoLabel, onUndo, onDismiss }: UndoNoticeProps) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, SHOWN_FOR_MS);
    return () => {
      window.clearTimeout(timer);
    };
  }, [message, onDismiss]);
  return (
    <div role="status" aria-live="polite" className="app-undo-notice">
      <span>{message}</span>
      <button type="button" className="app-undo-notice-action" onClick={onUndo}>
        {undoLabel}
      </button>
    </div>
  );
}
